import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { site } from '../data/site';
import { useSeo } from '../hooks/useSeo';
export function Accessibilite() {
  useSeo({
    title: 'Accessibilité & handicap — Zillenium Academy',
    description: 'Zillenium Academy étudie les aménagements possibles en fonction des besoins du bénéficiaire. Référent handicap : samir@zilleniumacademy.fr.'
  });
  return <>
      <section className="border-b border-surface-line bg-surface-soft" data-id="element-137" data-mp="2u1gjnsk53mep">
        <div className="mx-auto max-w-content px-5 py-14 lg:px-8 lg:py-16" data-id="element-138" data-mp="2pzv05od3o9vj">
          <h1 className="max-w-3xl text-4xl font-extrabold leading-tight text-ink md:text-[46px]" data-id="element-139" data-mp="33yurx4vwt4vx">
            Accessibilité aux personnes en situation de handicap
          </h1>
          <p className="mt-4 max-w-2xl text-lg leading-relaxed text-ink-muted" data-id="element-140" data-mp="j72kc02o5but">
            Zillenium Academy étudie les aménagements possibles en fonction des besoins du
            bénéficiaire. Signalez votre situation le plus tôt possible : c’est ce qui nous permet
            d’organiser une solution adaptée avant le démarrage.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-content px-5 py-16 lg:px-8" data-id="element-141" data-mp="2zi4ti5aexicr">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_0.8fr]" data-id="element-142" data-mp="2ziwiuydf2jul">
          <div data-id="element-143" data-mp="34g6ewwvb9tre">
            <h2 className="text-2xl font-bold text-ink" data-id="element-144" data-mp="34gpkrf7osrp2">Comment faire votre demande</h2>
            <ol className="mt-6 space-y-5" data-id="element-145" data-mp="26us7bw85zcjz">
              {['Signalez votre situation dès la demande d’information ou de devis, ou directement auprès du référent handicap.', 'Un échange confidentiel permet d’identifier vos besoins concrets d’adaptation.', 'Les aménagements envisageables sont étudiés puis confirmés avec vous avant le démarrage de la formation.'].map((etape, i) => <li key={etape} className="flex gap-4" data-id="element-146" data-mp="1t22jdm92rxk8" data-mpi={i}>
                  <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-900 text-sm font-bold text-white" data-id="element-147" data-mp="1t0hp7xqoagmw">
                    {i + 1}
                  </span>
                  <p className="pt-1 text-[15px] leading-relaxed text-ink-muted" data-id="element-148" data-mp="1g1qn56knzvh4">{etape}</p>
                </li>)}
            </ol>

            <div className="mt-10 rounded-xl border border-surface-line bg-surface-soft p-6" data-id="element-149" data-mp="1psczmrx345vl">
              <h2 className="text-lg font-bold text-ink" data-id="element-150" data-mp="122ik22lds37n">Un point de vigilance</h2>
              <p className="mt-2 text-[15px] leading-relaxed text-ink-muted" data-id="element-151" data-mp="124buzu3119lg">
                Les aménagements dépendent de la nature du besoin, du lieu et du format de la
                formation. Chaque situation est donc étudiée au cas par cas, sans que vous ayez à
                justifier d’un diagnostic médical.
              </p>
            </div>
          </div>

          <aside className="h-fit rounded-xl border border-surface-line bg-white p-6 shadow-card" data-id="element-152" data-mp="2neaca8os9gzm">
            <h2 className="text-lg font-bold text-ink" data-id="element-153" data-mp="2ig8qhfzz33kg">Référent handicap</h2>
            <p className="mt-2 text-[15px] leading-relaxed text-ink-muted" data-id="element-154" data-mp="2pz89hkjiut3a">
              Contactez-nous en toute confidentialité, avant l’inscription si possible.
            </p>
            <a href={`mailto:${site.refHandicap}`} className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-accent-600 hover:underline" data-id="element-155" data-mp="2h03c4hjp55sp">
              <MailIcon size={16} aria-hidden data-id="element-156" data-mp="38q98g8kn6omu" />
              {site.refHandicap}
            </a>
            <a href={`tel:${site.telephoneLien}`} className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-brand-800 hover:text-accent-600" data-id="element-157" data-mp="3dpkp7hl0du4f">
              <PhoneIcon size={16} aria-hidden data-id="element-158" data-mp="33zj32vc7uls5" />
              {site.telephone}
            </a>
            <Link to="/contact" className="mt-6 block rounded-lg bg-brand-900 px-5 py-3 text-center text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-800" data-id="element-159" data-mp="3rpvj6thm7ott">
              Passer par le formulaire
            </Link>
          </aside>
        </div>
      </section>
    </>;
}